import PropTypes from 'prop-types'
import React from 'react'
// @mui
import makeStyles from '@mui/styles/makeStyles'
import useScrollTrigger from '@mui/material/useScrollTrigger'
import Zoom from '@mui/material/Zoom'
//

const useStyles = makeStyles(theme => ({
  root: {
    position: 'fixed',
    bottom: theme.spacing(8),
    right: theme.spacing(2),
    zIndex: 1200, // above AppBar
  },
}))

const ScrollTop = (props) => {
  const { anchor, children, window } = props
  const classes = useStyles()
  // Note that you normally won't need to set the window ref as useScrollTrigger
  // will default to window.
  // This is only being set here because the demo is in an iframe.
  const scrollTarget = window && window() ? window() : undefined
  const trigger = useScrollTrigger({
    target: scrollTarget,
    disableHysteresis: true,
    threshold: 100,
  })

  const handleClick = event => {
    const anchorNode = (event.target.ownerDocument || document).querySelector(anchor)

    if (anchorNode) {
      anchorNode.scrollIntoView({ behavior: 'smooth', block: 'center' })
    }
  }

  return (
    <Zoom in={trigger}>
      <div onClick={handleClick} role="presentation" className={classes.root}>
        {children}
      </div>
    </Zoom>
  )
}
ScrollTop.propTypes = {
  children: PropTypes.element.isRequired,
  anchor: PropTypes.string.isRequired,
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
}

export default ScrollTop
